import React, { useCallback, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axiosInstance from '../helpers/axiosInstance';
import { useLoading } from '../context/LoadingContext';
import View from '../images/view.svg';
import { FaFilter } from 'react-icons/fa';
import { IoClose } from "react-icons/io5";
import Swal from 'sweetalert2';
import './employee.css';
import { useNavigate } from 'react-router-dom';

const Employee = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const { updateLoading } = useLoading();
    const [selectedStatus, setSelectedStatus] = useState('');
    const [showStatusFilter, setShowStatusFilter] = useState(false);
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [locations, setLocations] = useState([]);
    const [inputPage, setInputPage] = useState(1);
    const statusOptions = ["All", "Active", "Inactive"];
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        role: '',
        location: ''
    });

    const fetchEmployees = useCallback(async () => {
        try {
            console.log("Fetching employees...");
            updateLoading(true);
            const response = await axiosInstance.get(`/api/employee/employee`, {
                params: {
                    page, limit: 10, search: searchTerm, status: selectedStatus !== "all" ? selectedStatus : undefined,
                },
            });

            const employeesData = response.data.employees;
            const totalCount = employeesData.count;
            const limit = 10;
            const totalPages = Math.ceil(totalCount / limit);
            setEmployees(employeesData.rows);
            setTotalPages(totalPages);
        } catch (error) {
            console.error("Error fetching employees:", error);
        } finally {
            updateLoading(false);
        }
    }, [page, searchTerm, selectedStatus, updateLoading]);

    useEffect(() => {
        fetchEmployees();
    }, [fetchEmployees]);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await axiosInstance.get('/api/plant/AllLocations');
                setLocations(response.data.data);
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };

        fetchLocations();
    }, []);

    const handleView = (id) => {
        navigate(`/employee/${id}`);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Data:', formData);
        setShowSidebar(false);
        addEmployee();
    };

    useEffect(() => {
        setInputPage(page);
    }, [page]);


    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleInputChange = (e) => {
        setInputPage(e.target.value);
    };

    const handleInputSubmit = () => {
        const val = parseInt(inputPage, 10);
        if (!isNaN(val) && val >= 1 && val <= totalPages) {
            setPage(val);
        } else {
            setInputPage(page); // reset to current page if invalid
        }
    };

    const addEmployee = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.name || !formData.email || !formData.phone || !formData.role) {
            Swal.fire("Warning", "Please fill all required fields", "warning");
            return;
        }

        if (!emailRegex.test(formData.email)) {
            Swal.fire("Invalid Email", "Please enter a valid email address", "warning");
            return;
        }

        try {
            const payload = {
                name: formData.name.trim(),
                email: formData.email,
                mobile_number: formData.phone,
                password: formData.phone,
                role: formData.role,
                location_id: Number(formData.location)
            };

            const response = await axiosInstance.post('/api/employee/add-employee', payload);
            if (response.status === 200 || response.status === 201) {
                setEmployees([...employees, response.data.user]);
                Swal.fire("Success", response.data.message, "success");
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    role: '',
                    password: '',
                    location: ''
                });
                toggleSidebar();
            }
        } catch (error) {
            console.error("Error adding employee:", error);
            Swal.fire("Error", error.response?.data?.message || "Failed to add Employee", "error");
        }
    };


    return (
        <div className="container-fluid mt-5">
            <div className="responsive-scroll">
                <div className="d-flex justify-content-between align-items-center mb-2 me-4 ms-4">
                    <input
                        type="text"
                        className="form-control w-25 rounded-pill"
                        placeholder="Search by Employee name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button
                        className="btn"
                        onClick={toggleSidebar}
                        style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                    >
                        Add Employee
                    </button>
                </div>

                <div className="table-responsive mx-4 mt-4">
                    <table className="table custom-table table-sm">
                        <thead className="text-white">
                            <tr>
                                <th className="text-center text-white py-2 px-0" style={{ backgroundColor: "#0A4595" }}>Sl No</th>
                                <th className="text-center text-white py-2 px-0" style={{ backgroundColor: "#0A4595" }}>Name</th>
                                <th className="text-center text-white py-2 px-0" style={{ backgroundColor: "#0A4595" }}>Role</th>
                                <th className="text-center text-white py-2 px-0" style={{ backgroundColor: "#0A4595" }}>Location</th>
                                <th className="text-center py-2 px-0 position-relative" style={{ backgroundColor: "#0A4595", color: 'white' }}>
                                    Status

                                    <FaFilter className="ms-2 cursor-pointer" onClick={() => setShowStatusFilter(!showStatusFilter)} />
                                    <br />
                                    {showStatusFilter && (
                                        <div
                                            className="dropdown-menu show p-2 shadow rounded"
                                            style={{ backgroundColor: "#f8f9fa", zIndex: 20, minWidth: "150px", position: "fixed" }}
                                        >
                                            {statusOptions.map((status) => (
                                                <div
                                                    key={status}
                                                    className="dropdown-item rounded px-3 py-2 text-dark fw-semibold hover-bg"
                                                    onClick={() => {
                                                        setSelectedStatus(status.toLowerCase());
                                                        setShowStatusFilter(false);
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        transition: "background-color 0.2s",
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e9ecef")}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                                                >
                                                    {status}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {selectedStatus && (
                                        <div className="bg-light d-inline-flex align-items-center px-1 py-0 rounded" style={{ fontSize: "12px", marginLeft: "5px", color: 'black' }}>
                                            {selectedStatus}
                                            <IoClose className="text-danger cursor-pointer ms-1" style={{ fontSize: "14px" }} onClick={() => setSelectedStatus("")} />
                                        </div>
                                    )}
                                </th>
                                <th className="text-center text-white py-2 px-0" style={{ backgroundColor: "#0A4595" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employees.length > 0 ? (
                                employees.map((employee, index) => (
                                    <tr key={employee.id}>
                                        <td className="text-center p-2">{(page - 1) * 10 + index + 1}                                                                                                                                           </td>
                                        <td className="text-center p-2">{employee.name}</td>
                                        <td className="text-center p-2">{employee.role}</td>
                                        <td className="text-center p-2">
                                            {employee.location ? employee.location.location_name : "--"}
                                        </td>
                                        <td className="text-center p-2">{employee.status}</td>
                                        <td className="text-center p-2">
                                            <img src={View} alt="View" className="action-icon  mx-2" style={{ width: "18px", height: "18px", cursor: "pointer" }} onClick={() => handleView(employee.id)} title="View" />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center p-3">No employees available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="row justify-content-center mt-4 mb-5">
                    {/* Previous Button */}
                    <div className="col-auto">
                        <button
                            className="btn btn-sm mx-2"
                            onClick={() => handlePageChange(page - 1)}
                            style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                            disabled={page === 1}
                        >
                            Previous
                        </button>
                    </div>

                    {/* Page Input */}
                    <div className="col-auto d-flex align-items-center">
                        <span className="mx-2">Page</span>
                        <input
                            type="number"
                            value={employees.length === 0 ? 0 : inputPage}
                            onChange={handleInputChange}
                            onBlur={handleInputSubmit}
                            onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
                            style={{
                                width: "60px",
                                textAlign: "center",
                                borderRadius: "4px",
                                border: "1px solid #ccc",
                                padding: "4px"
                            }}
                            min={employees.length === 0 ? 0 : 1}
                            max={totalPages}
                            disabled={employees.length === 0}
                        />
                        <span className="mx-2">of {totalPages}</span>
                    </div>

                    {/* Next Button */}
                    <div className="col-auto">
                        <button
                            className="btn btn-sm mx-2"
                            onClick={() => handlePageChange(page + 1)}
                            style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}
                            disabled={page === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </div>


                {showSidebar && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 1040
                        }}
                    ></div>
                )}

                <div
                    className={`position-fixed top-0 end-0 bg-light p-3 shadow h-100 rounded`}
                    style={{
                        width: '100%',
                        maxWidth: '400px',
                        transform: showSidebar ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.3s ease-in-out',
                        zIndex: 1050
                    }}
                >
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                            <h5 className="mb-2">👤 Add Employee</h5>
                            <small className="text-muted">
                                Please provide accurate details to ensure a smooth and seamless onboarding experience.
                            </small>
                        </div>
                        <button className="btn-close ms-3 mt-1" onClick={toggleSidebar}></button>
                    </div>

                    <form className="employee-form" onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label form-label-custom">Name <span className="text-danger">*</span></label>
                            <input type="text" name="name" className="form-control form-control-custom" placeholder="Jane Smith" value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label form-label-custom">Email <span className="text-danger">*</span></label>
                            <input type="email" name="email" className="form-control form-control-custom" placeholder="email@gmail.com" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label form-label-custom">Mobile Number <span className="text-danger">*</span></label>
                            <input type="text" name="phone" className="form-control form-control-custom" placeholder="Enter Phone Number" maxLength={10} value={formData.phone} onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label form-label-custom">Role <span className="text-danger">*</span></label>
                            <select name="role" className="form-select form-select-custom" value={formData.role} onChange={handleChange} required>
                                <option value="">Select Role</option>
                                <option value="admin">Admin</option>
                                <option value="operator">Operator</option>
                            </select>
                        </div>
                        <div className='mb-3'>
                            <label className="form-label form-label-custom">Password</label>
                            <input type="password" name="password" style={{ background: "#B0B0B0" }} className="form-control form-control-custom" placeholder="********" value={formData.phone} readOnly required />
                        </div>
                        {formData.role === 'operator' && (
                            <div className="mb-3">
                                <label className="form-label form-label-custom">Location</label>
                                <select
                                    name="location"
                                    className="form-select form-select-custom"
                                    value={formData.location}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Location</option>
                                    {locations.map((loc) => (
                                        <option key={loc.id} value={loc.id}>
                                            {loc.location_name} {loc.module ? `${loc.module.module_name}` : "(N/A)"}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <small className="text-muted d-block mb-2">
                            <span className="text-danger">*</span> All fields are mandatory
                        </small>
                        <button type="submit" className="btn w-100" style={{ backgroundColor: "rgb(10, 69, 149)", color: "white" }}>
                            Add
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Employee;
